import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import DragAndDroppable from 'owa-dnd/lib/components/DragAndDroppable';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import { GroupRightCharm, GroupRightCharmHover, lazyDropMailListRowsOnGroup, } from 'owa-group-left-nav-mail';
import GroupNode from 'owa-group-left-nav/lib/components/GroupNode';
import { getFavoriteNodeViewStateFromId } from 'owa-mail-favorites-store';
import { showFavoritesContextMenu } from 'owa-mail-favorites-store/lib/actions/favoritesContextMenu';
import { isGroupNodeSelected, selectGroup } from 'owa-mail-folder-forest-actions';
import { DRAG_X_OFFSET, DRAG_Y_OFFSET } from 'owa-mail-folder-view';
import { getAnchorForContextMenu } from 'owa-positioning';
import * as React from 'react';
import { getFavoriteIdFromGroupId, lazyUpdateFavoritePosition } from 'owa-favorites';
var styles = require('./FavoriteNode.scss');
var FavoriteGroupNode = /** @class */ (function (_super) {
    tslib_1.__extends(FavoriteGroupNode, _super);
    function FavoriteGroupNode(props) {
        var _this = _super.call(this, props) || this;
        _this.onContextMenu = function (evt) {
            evt.stopPropagation();
            evt.preventDefault();
            showFavoritesContextMenu(_this.props.favoriteId, 2 /* Group */, null, // Folder - no Folder Object passed in for Groups context menu
            getAnchorForContextMenu(evt));
        };
        _this.onDrop = function (dragData) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var itemType, _a, draggedFavorite, dropTargetId, dragTargetId, updateFavoritePosition;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        itemType = dragData.itemType;
                        _a = itemType;
                        switch (_a) {
                            case DraggableItemTypes.FavoriteNode: return [3 /*break*/, 1];
                            case DraggableItemTypes.MultiMailListMessageRows: return [3 /*break*/, 3];
                            case DraggableItemTypes.MailListRow: return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        draggedFavorite = dragData;
                        dropTargetId = this.props.favoriteId;
                        dragTargetId = draggedFavorite.favoriteId;
                        return [4 /*yield*/, lazyUpdateFavoritePosition.import()];
                    case 2:
                        updateFavoritePosition = _b.sent();
                        updateFavoritePosition(dragTargetId, // idToUpdate
                        dropTargetId, // destinationFolderId
                        draggedFavorite.favoriteType);
                        return [3 /*break*/, 4];
                    case 3:
                        lazyDropMailListRowsOnGroup.importAndExecute(dragData, this.props.groupId);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.canDrop = function (dragData) {
            var itemType = dragData.itemType;
            switch (itemType) {
                case DraggableItemTypes.FavoriteNode:
                case DraggableItemTypes.MailListRow:
                case DraggableItemTypes.MultiMailListMessageRows:
                    return true;
                default:
                    return false;
            }
        };
        _this.onDragOver = function (dragData) {
            _this.isDragOver = true;
        };
        _this.onDragLeave = function () {
            _this.isDragOver = false;
        };
        _this.getDragData = function () {
            var displayName = _this.props.displayName;
            var groupNodeDragData = {
                itemType: DraggableItemTypes.FavoriteNode,
                favoriteId: _this.props.favoriteId,
                favoriteType: 2 /* Group */,
                displayName: displayName,
            };
            return groupNodeDragData;
        };
        _this.getDragPreview = function (groupNodeDragData) {
            var elem = document.createElement('div');
            elem.className = styles.dragPreview;
            elem.innerText = groupNodeDragData.displayName;
            return elem;
        };
        return _this;
    }
    FavoriteGroupNode.prototype.render = function () {
        var favoriteId = getFavoriteIdFromGroupId(this.props.groupId);
        var viewState = getFavoriteNodeViewStateFromId(favoriteId);
        return (React.createElement(DragAndDroppable, { dragViewState: viewState.drag, getDragData: this.getDragData, getDragPreview: this.getDragPreview, xOffset: DRAG_X_OFFSET, yOffset: DRAG_Y_OFFSET, dropViewState: viewState.drop, onDrop: this.onDrop, canDrop: this.canDrop, onDragOver: this.onDragOver, onDragLeave: this.onDragLeave },
            React.createElement(GroupNode, { selectGroup: this.selectGroupInternal, isSelected: this.isGroupNodeSelectedInternal, renderRightCharm: this.renderRightCharm, renderRightCharmHover: this.renderRightCharmHover, displayName: this.props.displayName, groupId: this.props.groupId, customIcon: "People" /* People */, isDroppedOver: viewState.drop.isDragOver && this.isDragOver, isBeingDragged: viewState.drag.isBeingDragged, key: this.props.groupId, onContextMenu: this.onContextMenu, showHoverStateOnDroppedOver: viewState.drop.draggableItemType == DraggableItemTypes.MailListRow ||
                    viewState.drop.draggableItemType ==
                        DraggableItemTypes.MultiMailListMessageRows })));
    };
    FavoriteGroupNode.prototype.renderRightCharm = function (groupId, customData) {
        return React.createElement(GroupRightCharm, { groupId: groupId });
    };
    FavoriteGroupNode.prototype.renderRightCharmHover = function (groupId, customData) {
        return React.createElement(GroupRightCharmHover, { groupId: groupId });
    };
    FavoriteGroupNode.prototype.selectGroupInternal = function (groupId, customData) {
        selectGroup(groupId, 'favorites');
    };
    FavoriteGroupNode.prototype.isGroupNodeSelectedInternal = function (groupId, customData) {
        return isGroupNodeSelected(groupId, 'favorites');
    };
    FavoriteGroupNode = tslib_1.__decorate([
        observer
    ], FavoriteGroupNode);
    return FavoriteGroupNode;
}(React.Component));
export default FavoriteGroupNode;
//# sourceMappingURL=FavoriteGroupNode.js.map